import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faShieldHalved,
  faCodeMerge,
  faServer,
  faMagnifyingGlass,
  faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { personalInfo, capabilities } from "../data/portfolioData";
import HeroVisual from "../components/HeroVisual";

export default function Home() {
  const iconMap = {
    "shield-halved": faShieldHalved,
    "code-merge": faCodeMerge,
    server: faServer,
    "magnifying-glass": faMagnifyingGlass,
  };

  return (
    <section id="home" className="cyber-section pt-4 pt-md-5">
      <div className="container">
        {/* Top Status & Label */}
        <div className="d-flex flex-wrap align-items-center gap-3 mb-4">
          <div className="status-pill">
            <span className="status-dot" />
            <span>{personalInfo.status}</span>
          </div>

          <span className="section-label mb-0">{personalInfo.label}</span>
        </div>

        {/* Hero Grid */}
        <div className="row g-5 align-items-center mb-5">
          {/* Left Column: Intro & Headline */}
          <div className="col-lg-7">
            <h1
              style={{
                fontSize: "clamp(2.4rem, 5vw, 3.8rem)",
                fontWeight: 800,
                lineHeight: 1.15,
                letterSpacing: "-0.03em",
                color: "var(--text-primary)",
                marginBottom: "20px",
              }}
            >
              Security Analyst building{" "}
              <span
                style={{
                  background: "linear-gradient(135deg, #38BDF8 0%, #818CF8 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                practical security
              </span>{" "}
              solutions.
            </h1>

            <p
              style={{
                fontSize: "1.15rem",
                color: "var(--text-secondary)",
                lineHeight: 1.7,
                maxWidth: "600px",
                marginBottom: "32px",
              }}
            >
              {personalInfo.subheadline}
            </p>

            {/* CTAs */}
            <div className="d-flex flex-wrap align-items-center gap-3">
              <a href="#projects" className="btn-cyber-primary">
                View My Work
                <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: "0.85rem" }} />
              </a>

              <a href="#contact" className="btn-cyber-secondary">
                Contact Me
              </a>

              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-cyber-ghost"
              >
                LinkedIn <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: "0.75rem" }} />
              </a>
            </div>

            {/* Meta details */}
            <div className="d-flex flex-wrap align-items-center gap-4 mt-4 pt-3" style={{ borderTop: "1px solid var(--border-subtle)" }}>
              <div className="font-mono text-muted" style={{ fontSize: "0.82rem" }}>
                Location: <span style={{ color: "var(--text-primary)" }}>{personalInfo.location}</span>
              </div>
              <div className="font-mono text-muted" style={{ fontSize: "0.82rem" }}>
                Specialization: <span style={{ color: "var(--accent)" }}>SIEM • VAPT • Hardening</span>
              </div>
            </div>
          </div>

          {/* Right Column: Hero Visual Architecture */}
          <div className="col-lg-5">
            <HeroVisual />
          </div>
        </div>

        {/* Capabilities Section */}
        <div className="pt-4">
          <div className="row g-3">
            {capabilities.map((cap) => (
              <div key={cap.id} className="col-md-6 col-lg-3">
                <div
                  className="cyber-card h-100 p-4"
                  style={{
                    background: "var(--bg-surface)",
                    borderColor: "var(--border-subtle)",
                  }}
                >
                  <div
                    style={{
                      width: 42,
                      height: 42,
                      borderRadius: "10px",
                      background: `${cap.accent}15`,
                      border: `1px solid ${cap.accent}30`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: cap.accent,
                      marginBottom: "16px",
                      fontSize: "1.1rem",
                    }}
                  >
                    <FontAwesomeIcon icon={iconMap[cap.icon] || faShieldHalved} />
                  </div>

                  <h3 style={{ fontSize: "1.15rem", fontWeight: 700, marginBottom: "8px" }}>
                    {cap.title}
                  </h3>

                  <p style={{ fontSize: "0.85rem", color: "var(--text-secondary)", marginBottom: "16px", minHeight: "38px" }}>
                    {cap.description}
                  </p>

                  <div className="d-flex flex-wrap gap-1">
                    {cap.items.map((item, idx) => (
                      <span key={idx} className="cyber-tag font-mono">
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
